<template>
  <Modal ref="baseModal">
    <div class="modal-inner lg-size">
      <div class="modal-body">
        <h3>개인정보 제공 및 활용 동의</h3>
        <p class="mt-sm">
          <b>본 강의는 <span class="blue">비수도권 소재 담당 교육기관에서 진행</span>됩니다</b><br/>
          개인정보의 수집·이용·제공 및 활용에 대한 약관을 확인하신 후 동의해주세요.
        </p>
        <div class="terms-wrap">
          <div class="terms-box">
            <b>[개인정보의 수집 및 이용 목적]</b><br/>
            1. 교육지원 및 교육이력관리<br/>
            2. 회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정이용 방지와 비인가사용 방지, 가입의사 확인, 연력확인, 불만처리 등 민원처리, 고지사항 전달<br/>
            3. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 교육생모집, 교육생선발, 학습진행, 콘텐츠 제공 등<br/>
            4. 교육위탁기관의 교육생모집, 교육생선발, 학습진행, 콘텐츠 제공 등<br/>
            5. 교육과정 만족도 조사 등 설문조사<br/><br/>

            <b>[개인정보의 수집 및 이용항목]</b><br/>
            이름, 핸드폰 번호, 이메일, 거주지역, 학력, 학교, 전공, 성적증명서, 포트폴리오(수상작, 논문, 프로젝트 결과물 등), 자격증 및 외국어 능력, 업무 경험(경력 정보), 병역 유무 등<br/><br/>

            <b>[수집한 개인정보의 보유 · 이용기간]</b><br/>
            개인정보를 이용목적이 달성된 후에는 회원탈퇴 시까지 보유하고 회원탈퇴 이후에는 해당 정보를 지체 없이 파기<br/><br/>

            <b>[수집 거부 및 불이익]</b><br/>
            귀하는 본 개인정보 수집 및 이용 동의를 거부할 수 있습니다. 다만, 개인정보 수집 및 이용 동의를 거부할 경우 한국디스플레이아카데미에서 실시하는 교육서비스 이용에 제한을 받을 수 있습니다.<br/><br/>
          </div>
        </div>
        <b>동의하지 않을 시 수강신청을 할 수 없습니다.</b>
      </div>
      <div class="modal-footer">
        <KSASecondaryButton class="full-btn" text="동의하지 않음" @click="cancel" />
        <KSAPrimaryButton class="full-btn" text="동의" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, toRefs, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import {useUserStore} from "../../../stores/user";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import _ from 'lodash';

export default {
  name: "LectureRegCompleteModal",
  components: {
    Modal,
  },
  setup() {
    const baseModal = ref(null);
    const resolvePromise = ref(null);

    const show = () => {
      baseModal.value.open();
      return new Promise((resolve, _) => {
        resolvePromise.value = resolve;
      });
    };

    const confirm = () => {
      baseModal.value.close();
      resolvePromise.value(true);
    };

    const cancel = () => {
      baseModal.value.close();
      resolvePromise.value(false);
    };

    return { baseModal, show, confirm, cancel};
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.modal-inner {
  width: 564px !important;
  padding: 60px 30px !important;
  .modal-body {
    h3 {
      font-size: $font-size_xl !important;
      line-height: $line-height_lg !important;
    }
    .terms-wrap {
      margin: 20px 0;
      text-align: left;

      .terms-box {
        height: 180px;
        overflow-y: auto;
        @include font-size_xs;
        background: $gray-thin_color;
        border: $border_line;
        padding: 20px;
        margin: 10px 0 40px;
      }
    }
  }
}
</style>